import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import City from '../entities/city';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface CityState extends ListState<City> {
  city: City;
  selectCity: City;
}

class CityMutations extends ListMutations<City> {}

class CityModule extends ListModule<CityState, any, City> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<City>(),
    loading: false,
    editCountry: new City(),
    selectCountry: new City(),
  };
  actions = {
    async getCities(context: ActionContext<CityState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        '/api/services/app/Content/GetCities?input=' + payload.data
      );

      context.state.loading = false;
      let page = reponse.data.result as PageResult<City>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
  };
  mutations = {
    setCurrentPage(state: CityState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: CityState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const cityModule = new CityModule();
export default cityModule;
